import * as React from 'react';
import * as style from './WhatToDoBlock.css';

export interface IWhatToDoBlockProps {
  message: string;
}

export const WhatToDoBlock = ({ message }: IWhatToDoBlockProps) => (
  <div className={style['container']}>
    <div className={style['title']}>Что нужно сделать?</div>
    <div className={style['message']}>{message}</div>
  </div>
);
